import { useSubmitCartMutation } from 'src/api/@generated/backend-api';

import { useCustomerInfoQueryStateOrThrow } from 'src/hooks/use-customer-info-query';
import { useInitializeShoppingCart } from 'src/hooks/use-initialize-shopping-cart';
import { selectSelectedAccountOrThrow } from 'src/state/account/selectors';
import { selectSelectedServiceLocationOrThrow } from 'src/state/address/selectors';
import { goToStepActionCreator } from 'src/state/order/action-creators/go-to-step-action-creator';
import { selectDeliveryType } from 'src/state/order/selectors';
import { OrderStep } from 'src/state/order/types';
import { useAppDispatch, useAppSelector } from 'src/state/thunk-api';
import { getOrThrow } from 'src/utils/type-utils';

export const useSelectSubmitShoppingCartState = () => {
  const [, { isLoading, isError, isSuccess, data: orderConfirmation }] = useSubmitCartMutation({
    fixedCacheKey: 'submit-shopping-cart',
  });

  return { isLoading, isError, isSuccess, orderConfirmation };
};

export const useSubmitShoppingCartMutation = () => {
  const selectedAccount = useAppSelector(selectSelectedAccountOrThrow);
  const selectedServiceLocation = useAppSelector(selectSelectedServiceLocationOrThrow);
  const deliveryType = useAppSelector(selectDeliveryType);
  const {
    userInfo: { userDetails },
  } = useCustomerInfoQueryStateOrThrow();
  const { shoppingCart } = useInitializeShoppingCart();
  const dispatch = useAppDispatch();

  const [submitShoppingCartMutationTrigger] = useSubmitCartMutation({ fixedCacheKey: 'submit-shopping-cart' });

  const submitShoppingCart = () => {
    dispatch(goToStepActionCreator(OrderStep.SUCCESS));
    const shoppingCartId = getOrThrow(shoppingCart?.shoppingCartId, 'Invalid state. Shopping cart must be present');

    return submitShoppingCartMutationTrigger({
      partnerId: selectedAccount.partnerId,
      cartId: shoppingCartId,
      submitShoppingCartRequest: {
        deliveryType,
        addressId: `${selectedServiceLocation.siteId}`,
        customerInformation: { firstName: userDetails.firstName, lastName: userDetails.lastName },
      },
    });
  };

  return { submitShoppingCart };
};
